export const TICKET_STATUS_META = {
  new: { label: "New", cls: "border-blue-200 text-blue-700 bg-blue-50 dark:border-blue-500/30 dark:text-blue-400 dark:bg-blue-500/10" },
  in_progress: { label: "In Progress", cls: "border-amber-200 text-amber-700 bg-amber-50 dark:border-amber-500/30 dark:text-amber-400 dark:bg-amber-500/10" },
  awaiting_customer: { label: "Awaiting Customer", cls: "border-violet-200 text-violet-700 bg-violet-50 dark:border-violet-500/30 dark:text-violet-400 dark:bg-violet-500/10" },
  resolved: { label: "Resolved", cls: "border-emerald-200 text-emerald-700 bg-emerald-50 dark:border-emerald-500/30 dark:text-emerald-400 dark:bg-emerald-500/10" },
};

export const TICKET_STATUS_ORDER = ["new", "in_progress", "awaiting_customer", "resolved"];

export const TICKET_PRIORITY_META = {
  low: { label: "Low", cls: "border-slate-200 text-slate-600 bg-slate-50 dark:border-white/15 dark:text-slate-300 dark:bg-white/5" },
  medium: { label: "Medium", cls: "border-blue-200 text-blue-700 bg-blue-50 dark:border-blue-500/30 dark:text-blue-400 dark:bg-blue-500/10" },
  high: { label: "High", cls: "border-orange-200 text-orange-700 bg-orange-50 dark:border-orange-500/30 dark:text-orange-400 dark:bg-orange-500/10" },
  urgent: { label: "Urgent", cls: "border-red-200 text-red-700 bg-red-50 dark:border-red-500/30 dark:text-red-400 dark:bg-red-500/10" },
};

export const WARRANTY_STATUS_META = {
  submitted: { label: "Submitted", cls: "border-blue-200 text-blue-700 bg-blue-50 dark:border-blue-500/30 dark:text-blue-400 dark:bg-blue-500/10" },
  in_review: { label: "In Review", cls: "border-amber-200 text-amber-700 bg-amber-50 dark:border-amber-500/30 dark:text-amber-400 dark:bg-amber-500/10" },
  approved: { label: "Approved", cls: "border-emerald-200 text-emerald-700 bg-emerald-50 dark:border-emerald-500/30 dark:text-emerald-400 dark:bg-emerald-500/10" },
  denied: { label: "Denied", cls: "border-red-200 text-red-700 bg-red-50 dark:border-red-500/30 dark:text-red-400 dark:bg-red-500/10" },
};

export const starRow = (rating) => "★".repeat(rating) + "☆".repeat(5 - rating);

export const formatHours = (v) => {
  if (v == null) return "—";
  if (v < 1) return `${Math.max(1, Math.round(v * 60))}m`;
  return v < 24 ? `${v}h` : `${(v / 24).toFixed(1)}d`;
};
export const formatDays = (v) => (v == null ? "—" : `${v}d`);
